import React from 'react';
import {Layout} from 'antd';
import {useSocketSystem} from './components/useSocketSystem';

const AppFooter = ({disableFooter}) => {
    const {Footer} = Layout;
    useSocketSystem()

    return !disableFooter &&
        <Footer style={{textAlign: 'center'}}>کلیه حقوق مادی و معنوی این سایت متعلق به پینگی می باشد</Footer>
}

export default AppFooter;